import React, { useEffect, useState } from 'react'
import './header.css'
import Logo1 from '../../assets/Logoweb.png'
import Aos from 'aos';
import 'aos/dist/aos.css';

const Header = ({darkMode, setDarkMode}) => {

  //Animation
  useEffect(() => {
    Aos.init({
        duration: 2000,
        once: false,
    });
  },[]);

  // Si al hacer el scroll, pasa el tamaño de 90vh, a la clase header, se le agregará la clase active
  window.addEventListener("scroll", function () {
    const header = document.querySelector(".header")
    header.classList.toggle("active", window.scrollY > 90)
  })

  // Toogle Menu
  // const [Mobile, setMobile] = useState(false)

  return (
    <>
        <header className='header'>
            <section data-aos="fade-down" className='container'>
                <div className='container__img'>
                    <img src={Logo1}></img>
                </div>

                <div className='container__list'>
                    <ul>
                        <li><a href='#'>Home</a></li>
                        <li><a href='#portfolio'>Portfolio</a></li>
                        <li><a href='#resume'>Resume</a></li>
                        <li><a href='#experience'>Experience</a></li>
                        {/* <li><a href='#contact'>Contact</a></li> */}
                    </ul>
                </div>

                <div className='container__buttons'>
                    {/* <label className="label">
                        <div className="toggle">
                            <input 
                                className="toggle-state" 
                                type="checkbox" 
                                name="check" 
                                value="check" 
                                onChange={() => setDarkMode(!darkMode)}/>
                            <div className="indicator"></div>
                        </div>
                    </label> */}
                    <a href='#contact'><button  className='header__button'>CONTACT</button></a>
                </div>
            </section>
        </header>

        {/* <button className='toggle' onClick={() => setMobile(!Mobile)}>
            {Mobile ? <i className='fas fa-times close home-btn'></i> : <i className='fas fa-bars open'></i>}
        </button> */}
    </>
  )
}

export default Header